import { DefaultAttributeValue } from '@source-components-react/types';
import {
  ACCORDION_DETAIL_ATTRIBUTE,
  ACCORDION_HEADING_LEVEL_ATTRIBUTE,
  ACCORDION_INLINE_STYLES_ATTRIBUTE,
  ACCORDION_LINKS_ATTRIBUTE,
  ACCORDION_OPEN_ATTRIBUTE,
  ACCORDION_SUMMARY_ATTRIBUTE,
  DEFAULT_ACCORDION_DETAIL,
  DEFAULT_ACCORDION_HEADING_LEVEL,
  DEFAULT_ACCORDION_SUMMARY,
} from './accordion-attributes';

export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: ACCORDION_SUMMARY_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_ACCORDION_SUMMARY,
    },
  },
  {
    name: ACCORDION_DETAIL_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_ACCORDION_DETAIL,
    },
  },
  // Closed by default, and unset rather than 'false': a disclosure the author
  // has not thought about should start collapsed, which is what an absent
  // `open` attribute already means in HTML.
  {
    name: ACCORDION_OPEN_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: ACCORDION_HEADING_LEVEL_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_ACCORDION_HEADING_LEVEL,
    },
  },
  {
    name: ACCORDION_LINKS_ATTRIBUTE,
    defaultValues: {},
  },
  {
    name: ACCORDION_INLINE_STYLES_ATTRIBUTE,
    defaultValues: {},
  },
];
